module.exports = __webpack_public_path__ + "img/IMG-20200629-WA0030.da377342.jpg";